import { render, staticRenderFns } from "./ProgramMenu.vue?vue&type=template&id=c826576a&scoped=true&"
import script from "./ProgramMenu.vue?vue&type=script&lang=js&"
export * from "./ProgramMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c826576a",
  null
  
)

export default component.exports